// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import decommaName from './decommaName';

export default (search, doc) => {

    let matches = [];
    let count = 0;
    let queries;

    let s = search.toLowerCase().replace(/"/g, "");
    const mws = (s[0] === "*"); // Multi-word search

    if (mws) {
        s = s.substring(1);
        queries = s.split(" ");
    }

    if (!mws) {
        queries = [s];
        const decommaed = decommaName(search);
        if (decommaed) queries.push(decommaed);
    }

    // Break up query into multiple strings
    for (const wordIdx in doc.words) {

        for (const query of queries) {

            const q = query.split(" ");

            let match = false;
            let tmp = [];

            for (const [queryIdx, query] of q.entries()) {
                
                if (query.length < 1) continue;
                const tmpIdx = parseInt(wordIdx) + parseInt(queryIdx);
                if (tmpIdx >= doc.words.length) break;

                const word = doc.words[tmpIdx];

                // Check if query is in word
                if ((parseInt(queryIdx) === q.length-1 && word.text.toLowerCase().includes(query)) || word.text.toLowerCase() === query) {
                    tmp.push({
                        ...word,
                        query
                    });
                    match = true;
                }

                else {
                    match = false;
                    break;
                }

            }

            if (match) {
                for (let match of tmp)
                    matches.push({
                        ...match,
                        matchIdx: count
                    });
                count++;
            }
        }

    }

    return {
        search, 
        matches: {
            count,
            index: 0,
            words: matches
        },
        searching: false
    };
}